import {
  CONNECTED_SYSTEMS_FULL_TAGLINE,
  GROWTH_SERVICE_FULL_TAGLINE,
  MEDICAL_SERVICE_TAGLINE,
} from "@/lib/content/service-configs";

/** Eyebrow above the homepage services rotation. */
export const HOME_SERVICES_SECTION_EYEBROW =
  "The type of systems & sites we build";

export type HomeServiceWorkCategory =
  | "connected-systems"
  | "digital-experiences"
  | "medical-devices";

export type HomeServiceRotationItem = {
  id: "connected" | "growth" | "medical";
  number: string;
  title: string;
  tabLabel: string;
  tagline: string;
  description: string;
  href: string;
  ctaLabel: string;
  bgColor: string;
  workCategory: HomeServiceWorkCategory;
};

/** Homepage “services” tabs / panels — copy only; logic stays in `page.tsx`. */
export const HOME_SERVICE_ROTATION_ITEMS: readonly HomeServiceRotationItem[] = [
  {
    id: "connected",
    number: "01",
    title: "Intelligent Software That Connects the Dots",
    tabLabel: "Connected & Intelligent",
    tagline: CONNECTED_SYSTEMS_FULL_TAGLINE,
    description: "",
    href: "/connected",
    ctaLabel: "Connected & intelligent services",
    bgColor: "bg-brand-yellow",
    workCategory: "connected-systems",
  },
  {
    id: "growth",
    number: "02",
    title: "Marketing Sites That Grow and Evolve With You",
    tabLabel: "Digital Growth",
    tagline: GROWTH_SERVICE_FULL_TAGLINE,
    description: "",
    href: "/growth",
    ctaLabel: "Digital growth services",
    bgColor: "bg-brand-pink",
    workCategory: "digital-experiences",
  },
  {
    id: "medical",
    number: "03",
    title: "Software for Medical & Regulated Systems",
    tabLabel: "Medical & Regulated",
    tagline: MEDICAL_SERVICE_TAGLINE,
    description: "",
    href: "/medical",
    ctaLabel: "Medical & regulated services",
    bgColor: "bg-brand-teal",
    workCategory: "medical-devices",
  },
];

export const HOME_SERVICE_ROTATION_MS = 5000;

/** CTA when a service row has no dedicated `href` (should not happen for current data). */
export const HOME_SERVICE_CTA_FALLBACK = "Talk to Us";

/** “We’re a good fit when” band below delivery approach. */
export const HOME_GOOD_FIT_SECTION = {
  heading: "We’re a good fit when:",
  bullets: [
    "A website needs to become a real system",
    "Early experimentation needs to become something defensible",
    "Multiple tools, brands, or teams need a shared foundation",
    "When security and reliability become a priority",
  ] as const,
  supporting:
    "We’re especially helpful when the path forward isn't obvious yet.",
  ctaHref: "/contact",
  ctaLabel: "Talk to Us About Your Project",
} as const;
